<template>
  <div id="footer">
    <div :class="[lang === 'ar' ? 'flex-row-reverse' : '', 'row border-bottom-1 px-2 pb-3']">
      <!--      <div class="col-lg-2
       col-sm-3 col-6 text-sm-left text-center arabic" v-for="(item, j) in footer" :key="j">-->
      <div class="col-lg-2 col-sm-3 text-sm-left text-center arabic" v-for="(item, j) in footer" :key="j"
        :class="j === 2 ? 'col-12' : 'col-6'">
        <div
          :class="[lang === 'ar' ? 'justify-content-sm-end' : 'justify-content-sm-start', 'footer-title d-flex justify-content-center']">
          {{ item.title }}</div>
        <div v-for="(item, i) in footer[j].info" :key="i"
          :class="[lang === 'ar' ? 'flex-row-reverse' : '', 'd-flex justify-content-center justify-content-sm-start align-items-center']">
          <div class="ball-white-3"></div>
          <!--          <div class="mb-1 item"><a :href="web + item.url">{{item.title}}</a></div>-->
          <router-link v-if="j !== 2" :to="item.url">
            <div class="mb-1 item"><a :href="j === 2 && item.url">{{ item.title }}</a></div>
          </router-link>
          <div v-if="j === 2" class="mb-1 item"><a :href="item.url">{{ item.title }}</a></div>
        </div>
      </div>
      <!--      <div :class="[lang === 'ar' ? 'justify-content-sm-start' : 'justify-content-sm-end' ,'col-lg-4 col-sm-3 col-12 d-flex justify-content-center']">-->
      <div class="footerBtnContainer" :class="lang === 'ar' ? 'justify-content-start' : 'justify-content-end'"
        v-if="appDownload !== '' && appledownload !== ''">
        <div>
          <div class="footer-title">{{ $t('footer.downloadMtn') }}</div>
          <div class="buttons footerBtn">
            <v-btn class="flex-center download-btn mr-4" :href="appledownload" target="_blank">
              <img class="icon" src="../../assets/icons/applewhite.svg">
              <div>
                <div class="download">{{ $t('mtnApp.download') }}</div>
                <div class="site">iPhone</div>
              </div>
            </v-btn>
            <v-btn class="flex-center download-btn" :href="appDownload" target="_blank">
              <img class="icon" src="../../assets/icons/googlewhite.svg">
              <div>
                <div class="download">{{ $t('mtnApp.git') }}</div>
                <div class="site">Android</div>
              </div>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div :class="[lang === 'ar' ? 'flex-row-reverse' : '', 'row align-items-center px-2 py-3']">
      <div class="col-12" v-if="$store.state.window < 786">
        <a v-for="(item, i) in social" :key="i" :href="item.url" target="_blank" class="footer-icon">
          <svg width="40" height="40" viewBox="0 0 40 40" :style="{ 'transform': item.scale }"
            @mouseover="changeAtHover(i, 0)" @mouseout="changeAtHover(i, 1)">
            <path :d="item.points" :transform="item.transform" :fill="item.color" />
          </svg>
        </a>
      </div>
      <div :class="[lang === 'ar' ? ' text-sm-right' : 'text-sm-left', 'col-sm-4 col-12 text-center specify']">
        <div class="mb-1 terms">
          {{ $t('footer.terms') }}
        </div>
        <div class="terms" v-if="lang === 'ar'">
          © {{ new Date().getFullYear() }} مجموعة MTN، جميع الحقوق محفوظة.
        </div>
        <div class="terms" v-else>
          © {{ new Date().getFullYear() }} MTN GROUP, ALL RIGHTS RESERVED.
        </div>
      </div>
      <div class="col-sm-4 col-12" v-if="$store.state.window > 786">
        <a v-for="(item, i) in social" :key="i" :href="item.url" target="_blank" class="footer-icon">
          <svg width="40" height="40" viewBox="0 0 40 40" :style="{ 'transform': item.scale }"
            @mouseover="changeAtHover(i, 0)" @mouseout="changeAtHover(i, 1)">
            <path :d="item.points" :transform="item.transform" :fill="item.color" />
          </svg>
        </a>
      </div>
      <!--      <div v-else class="col-4" v-if=""></div>-->
      <div
        :class="[lang === 'ar' ? 'justify-content-sm-end flex-row-reverse' : 'justify-content-sm-end', 'col-sm-4 col-12 mtn text-sm-right d-flex justify-content-center align-items-center specify']">
        <div class="bold-italic">{{ $t('footer.everyWhere') }}</div>
        <div> <img src="../../assets/icons/mtn-white.svg"> </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import $ from 'jquery'
import gc from '../../utils/gc'
import CommercialAppRepository from '../../repositories/CommercialAppRepository'
import FooterAppsRepository from '../../repositories/FooterAppsRepository'
import BundlesCategoriesRepository from '../../repositories/BundlesCategoriesRepository'
export default {
  name: 'Footer',
  data () {
    return {
      bundlesCategoriesRepo: new BundlesCategoriesRepository(),
      footerAppsRepo: new FooterAppsRepository(),
      commericalApp: new CommercialAppRepository(),
      web: gc.website,
      lang: 'en',
      appDownload: '',
      appledownload: '',
      footer: [{
        title: this.$t('footer.aboutMTN'),
        info: [{ title: this.$t('footer.whoWeAre'), url: '/about-mtn/who-we-are' }, { title: this.$t('footer.socialResponse'), url: '/about-mtn/social-responsibility' }, { title: this.$t('footer.financialReport'), url: '/about-mtn/financial-reports' }]
      },
      // {
      //   title: this.$t('footer.mtnCareers'),
      //   info: [{ title: this.$t('footer.whyMtn'), url: '' }, { title: this.$t('footer.mtnJobs'), url: '' }, { title: this.$t('footer.emailHr'), url: '' }]
      // },
      {
        title: this.$t('footer.mtnBundles'),
        info: []
      },
      {
        type: 'apps',
        title: this.$t('footer.mtnApps'),
        info: []
      }
      ],
      social: [{ url: '', points: 'M11.25,40A11.25,11.25,0,0,1,0,28.75V11.25A11.25,11.25,0,0,1,11.25,0h17.5A11.25,11.25,0,0,1,40,11.25v17.5A11.25,11.25,0,0,1,28.75,40ZM3.5,11.25v17.5a7.758,7.758,0,0,0,7.75,7.75h17.5a7.758,7.758,0,0,0,7.75-7.75V11.25A7.758,7.758,0,0,0,28.75,3.5H11.25A7.758,7.758,0,0,0,3.5,11.25ZM17.407,31.759V21.693H13.75V17.529h3.657V14.355c0-3.611,2.151-5.6,5.442-5.6a22.151,22.151,0,0,1,3.224.281v3.545H24.258a2.082,2.082,0,0,0-2.348,2.25v2.7H25.9l-.639,4.164H21.91V31.759Z', color: '#FFF', transform: '', scale: '' },
        { url: '', points: 'M11.25,40A11.25,11.25,0,0,1,0,28.75V11.25A11.25,11.25,0,0,1,11.25,0h17.5A11.25,11.25,0,0,1,40,11.25v17.5A11.25,11.25,0,0,1,28.75,40ZM3.5,11.25v17.5a7.758,7.758,0,0,0,7.75,7.75h17.5a7.758,7.758,0,0,0,7.75-7.75V11.25A7.758,7.758,0,0,0,28.75,3.5H11.25A7.758,7.758,0,0,0,3.5,11.25ZM30.521,30.525H26.194v-6.8c0-1.62-.033-3.7-2.254-3.7-2.255,0-2.6,1.76-2.6,3.581v6.914H17.007V16.56h4.159v1.9h.061a4.558,4.558,0,0,1,4.1-2.255c4.39,0,5.2,2.89,5.2,6.643v7.671Zm-20.566,0V16.56h4.337V30.525ZM9.609,12.12a2.512,2.512,0,1,1,2.512,2.536A2.512,2.512,0,0,1,9.609,12.12Z', color: '#FFF', transform: '', scale: '' },
        { url: '', points: 'M20,11.982A10.255,10.255,0,1,0,30.252,22.238,10.238,10.238,0,0,0,20,11.982Zm0,16.923a6.667,6.667,0,1,1,6.666-6.667A6.679,6.679,0,0,1,20,28.905ZM33.063,11.563a2.392,2.392,0,1,1-2.392-2.392A2.386,2.386,0,0,1,33.063,11.563Zm6.791,2.428c-.152-3.2-.883-6.043-3.23-8.381s-5.176-3.07-8.379-3.231c-3.3-.187-13.2-.187-16.5,0C8.55,2.53,5.713,3.262,3.366,5.6S.3,10.777.135,13.982c-.187,3.3-.187,13.2,0,16.5.152,3.2.883,6.043,3.23,8.381s5.176,3.07,8.379,3.231c3.3.187,13.2.187,16.5,0,3.2-.152,6.041-.884,8.379-3.231s3.07-5.177,3.23-8.381c.187-3.3.187-13.192,0-16.494ZM35.589,34.028a6.75,6.75,0,0,1-3.8,3.8c-2.632,1.044-8.879.8-11.788.8s-9.165.232-11.788-.8a6.749,6.749,0,0,1-3.8-3.8c-1.044-2.633-.8-8.881-.8-11.791s-.232-9.167.8-11.791a6.749,6.749,0,0,1,3.8-3.8c2.632-1.044,8.879-.8,11.788-.8s9.165-.232,11.788.8a6.749,6.749,0,0,1,3.8,3.8c1.044,2.633.8,8.881.8,11.791S36.633,31.4,35.589,34.028Z', color: '#FFF', transform: 'translate(0.005 -2.238)', scale: '' },
        { url: '', points: 'M11.25,40A11.251,11.251,0,0,1,0,28.751V11.25A11.25,11.25,0,0,1,11.25,0h17.5A11.249,11.249,0,0,1,40,11.25v17.5A11.25,11.25,0,0,1,28.751,40ZM3.5,11.25v17.5a7.759,7.759,0,0,0,7.75,7.75h17.5a7.759,7.759,0,0,0,7.75-7.75V11.25a7.759,7.759,0,0,0-7.75-7.75H11.25A7.759,7.759,0,0,0,3.5,11.25ZM23.877,30.377c-.24-.181-4.521-2.893-6.088-4.219a1.143,1.143,0,0,1,.06-1.93c2.17-1.989,4.762-4.46,6.329-6.027.724-.724,1.447-2.412-1.567-.362l-8.5,5.726a3.541,3.541,0,0,1-2.773.06c-1.808-.542-3.919-1.265-3.919-1.265s-1.446-.9,1.025-1.868c3.686-1.506,17.024-7.031,20.134-8.319,0,0,2.17-.844,1.989,1.205-.06.844-.542,3.8-1.025,6.993l-1.507,9.464c-.172,1.237-.776,1.651-1.5,1.651A5.323,5.323,0,0,1,23.877,30.377Z', color: '#FFF', transform: '', scale: '' }
      ]
    }
  },
  created () {
    this.getBundles()
    this.getApps()
    if (localStorage.getItem('lang') !== '') {
      this.lang = localStorage.getItem('lang')
    }
    this.getCommerical()
    this.$watch(() => {
      return this.$store.state.links
    }, (val) => {
      for (let i = 0; i < val.length; i++) {
        if (val[i].type === 2) {
          this.social[1].url = val[i].link
        } else if (val[i].type === 1) {
          this.social[2].url = val[i].link
        } else if (val[i].type === 0) {
          this.social[3].url = val[i].link
        } else if (val[i].type === 3) {
          this.social[0].url = val[i].link
        }
      }
    })
    this.$watch(() => {
      return this.$store.state.bundleCategories
    }, (val) => {
      for (let i = 0; i < val.length; i++) {
        if (i > 3) {
          return
        }
        this.footer[1].info.push({ title: val[i].title, url: val[i].url })
      }
    })
    this.$watch(() => {
      return this.$store.state.mtnApps
    }, (val) => {
      for (let i = 0; i < val.length; i++) {
        if (i > 3) {
          return
        }
        this.footer[2].info.push({ title: val[i].title, url: '/app-details/' + val[i].id })
      }
    })
  },
  methods: {
    async getBundles () {
      try {
        const response = await this.bundlesCategoriesRepo.get()
        if (response.status === 200) {
          // console.log('personal', response)
          this.$store.state.bundleCategories = []
          for (let i = 0; i < response.data.length; i++) {
            this.$store.state.bundleCategories.push({ title: response.data[i].title, url: '/bundles/' + response.data[i].id, id: response.data[i].id })
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getApps () {
      try {
        const response = await this.footerAppsRepo.get()
        if (response.status === 200) {
          // this.footer[3].info = []
          this.$store.state.mtnApps = []
          for (let i = 0; i < response.data.length; i++) {
            if (i > 3) {
              return
            }
            this.$store.state.mtnApps.push({ title: response.data[i].title, url: response.data[i].link, id: response.data[i].id })
          }
          this.$forceUpdate()
        }
      } catch (e) {
        return e
      }
    },
    // async getBundles () {
    //   try {
    //     const response = await this.bundlesCategoriesRepo.get()
    //     if (response.status === 200) {
    //       for (let i = 0; i < response.data.length; i++) {
    //         this.$store.state.bundleCategories.push({ title: response.data[i].title, url: '/bundles/' + response.data[i].id, id: response.data[i].id })
    //       }
    //     }
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },
    // async getApps () {
    //   try {
    //     const response = await this.footerAppsRepo.get()
    //     if (response.status === 200) {
    //       this.footer[3].info = []
    //       for (let i = 0; i < response.data.length; i++) {
    //         if (i > 3) {
    //           return
    //         }
    //         this.footer[3].info.push({ title: response.data[i].title, url: response.data[i].link })
    //       }
    //       this.$forceUpdate()
    //       this.arabic()
    //     }
    //   } catch (e) {
    //     return e
    //   }
    // },
    // async getData () {
    //   try {
    //     const response = await this.commericalApp.get()
    //     console.log('huhuhuh', response)
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },
    async getCommerical () {
      try {
        const response = await this.commericalApp.get()
        if (response.status === 200) {
          this.appDownload = response.data.link
          this.appledownload = response.data.appleLink
          this.show = true
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.show = false
        this.error = true
        console.log(e)
      }
    },
    changeAtHover (index, type) {
      if (type === 0) {
        this.social[index].color = '#00678f'
        this.social[index].scale = 'scale(1.2)'
      } else {
        this.social[index].color = '#FFF'
        this.social[index].scale = 'scale(1)'
      }
    },
    arabic () {
      setTimeout(() => {
        // this.$lang === 'ar' ? $('#footer').css('font-family', 'Mtn-arabic-regular') : $('#footer').css('font-family', 'Mtn-regular')
        this.lang === 'ar' ? $('#footer .bold-text').css('font-family', 'Mtn-arabic-bold') : $('#footer .bold-text').css('font-family', 'Mtn-bold')
        this.lang === 'ar' ? $('#footer .item').css('font-family', 'Mtn-arabic-regular') : $('#footer .item').css('font-family', 'Mtn-regular')
        this.lang === 'ar' ? $('div .footer-title').css('font-family', 'Mtn-arabic-bold') : $('div .footer-title').css('font-family', 'Mtn-bold')
      })
      if (this.lang === 'ar') {
        $('.arabic').css('text-align', 'right !important')
      } else {
        $('.arabic').css('text-align', 'left !important')
      }
    }
  },
  mounted () {
    this.arabic()
    // this.getData()
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";

#footer {
  font-size: 12px;
}

#footer .terms {
  unicode-bidi: plaintext;
}

@media screen and (max-width: 360px) {
  #footer {
    font-size: 11px !important;
  }
}

.footer-title {
  font-size: 16px !important;
  margin-bottom: 0.8rem;
}

.v-btn {
  text-transform: initial !important;
}

.download {
  font-size: 10px !important;
  text-align: start;
}

.description {
  margin-bottom: 2.5rem;
}

.icon {
  margin-right: 7px;
  width: 22px;
}

.site {
  margin-top: -3px;
  font-size: 15px !important;
  font-family: Mtn-bold;
  text-align: start;
}

.padding-2 {
  padding: 2.5rem;
}

@media screen and (max-width: 600px) {
  .padding-2 {
    padding: 2rem !important;
  }
}

@media screen and (min-width: 380px) {
  .buttons {
    display: flex;
  }
}

.footerBtn .theme--light.v-btn.v-btn--has-bg {
  background-color: transparent;
}

.footerBtn .download-btn {
  border: solid 2.5px #ffffff !important;
  border-radius: 11px !important;
  width: 118.5px !important;
  height: 33px !important;
}

.footerBtn .site,
.footerBtn .download {
  color: #ffffff !important;
}

.footerBtn .download {
  font-size: 7px !important;
}

.footerBtn .icon {
  width: 17px !important;
}

.footerBtn .site {
  font-size: 11px !important;
}

.footerBtn .v-btn--is-elevated {
  box-shadow: none !important;
}

.footerBtnContainer {
  //width: 30%;
  width: 50%;
  padding: 12px;
  display: flex;
}

.buttons {
  justify-content: center;
}

@media screen and (max-width: 1000px) {
  .buttons {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .footerBtnContainer {
    width: 100%;
    justify-content: center !important;
  }

  #footer .row {
    justify-content: center;
  }
}

@media screen and (max-width: 590px) {
  #footer {
    padding: 1.5rem 1.5rem 0 1.5rem;
  }
}

@media screen and (min-width: 576px) and (max-width: 786px) {
  #footer .specify {
    width: 49% !important;
  }
}
</style>
